import { Loader2 } from "lucide-react";
import { DataTable } from "@/components/ui/data-table";
import type { Party } from "@/lib/party.api";
import { PartyGrid } from "../../party/components/PartyGrid";
import { partyColumns } from "../partyTableColumns";
import type { PartyViewMode } from "../parties.constants";

interface PartiesContentProps {
  parties: Party[];
  viewMode: PartyViewMode;
  isLoading: boolean;
}

export function PartiesContent({ parties, viewMode, isLoading }: PartiesContentProps) {
  if (isLoading) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  if (viewMode === "grid") {
    return <PartyGrid parties={parties} />;
  }

  return <DataTable columns={partyColumns} data={parties} emptyMessage="Aucune partie trouvée." />;
}
